import React, { useState } from 'react';
import { DEFAULT_WALL_SIDE_STYLE, normalizeWallCoveringType } from './Wall3D.jsx';
import './wallStyleBox.scss';

// پوشش‌های قابل‌انتخاب برای هر رویه: «رنگِ ساده» + عکس‌های واقعیِ PBR (Wall3D.jsx → pbrTextures.jsx)
const COVERING_TYPES = [
  { value: 'paint', label: 'رنگ' },
  { value: 'wallpaperPbr', label: 'کاغذ دیواری ✦' },
  { value: 'plasterPbr', label: 'گچِ بافت‌دار ✦' },
  { value: 'concretePbr', label: 'بتن/گچِ خاکستری ✦' },
  { value: 'ceramicPbr', label: 'کاشی ✦' },
  { value: 'brickPbr', label: 'آجر ✦' },
  { value: 'stoneSlabPbr', label: 'سنگِ رگه‌دار (مرمر) ✦' },
  { value: 'stonePbr', label: 'سنگِ لکه‌دار (گرانیت) ✦' },
  { value: 'travertinePbr', label: 'تراورتن ✦' },
  { value: 'woodPbr', label: 'روکشِ چوبِ روشن ✦' },
  { value: 'woodDarkPbr', label: 'روکشِ چوبِ تیره ✦' },
];

const COVERING_HINTS = {
  wallpaperPbr: 'عکسِ واقعیِ کاغذ دیواریِ بافت‌دار (کاغذِ سفید با برجستگیِ ریز) — رنگش کاملاً از «رنگ» می‌آید.',
  plasterPbr: 'عکسِ واقعیِ گچِ سفیدِ مات با برجستگیِ ماله‌کشی.',
  concretePbr: 'عکسِ واقعیِ بتن/گچِ خاکستریِ یک‌دست.',
  ceramicPbr: 'عکسِ واقعیِ کاشیِ سفیدِ براق، با بندکشیِ واقعی.',
  brickPbr: 'عکسِ واقعیِ آجرچینِ نارنجی/قرمز.',
  stoneSlabPbr: 'عکسِ واقعیِ مرمرِ رگه‌دار.',
  stonePbr: 'عکسِ واقعیِ گرانیتِ لکه‌دار.',
  travertinePbr: 'عکسِ واقعیِ سنگِ تراورتنِ کرم با رگه‌های افقی — رایج برای حمام، پذیرایی و نما.',
  woodPbr: 'عکسِ واقعیِ چوبِ کاجِ روشن با رگه‌های عمودی — روکشِ چوبی/لمبه.',
  woodDarkPbr: 'عکسِ واقعیِ چوبِ تیره‌ی گردویی با رگه‌های افقی.',
};

const MAIN_COLOR_PRESETS = ['#ffffff', '#f4ede1', '#e8dfd0', '#d7e4ea', '#dbe8d8', '#2f333a'];
const BASEBOARD_COLOR_PRESETS = ['#cdc6b8', '#ffffff', '#3a3a3a', '#8a5a3b'];

const TABS = [
  { id: 'covering', label: 'پوشش' },
  { id: 'finish', label: 'براقیت' },
  { id: 'baseboard', label: 'قرنیز' },
];

function ColorField({ label, value, presets, onChange }) {
  return (
    <div className="wall-style-box__field">
      {label && <span className="wall-style-box__label">{label}</span>}
      <div className="wall-style-box__swatches">
        {presets.map((c) => (
          <button
            key={c}
            type="button"
            className={`wall-style-box__swatch ${value === c ? 'is-active' : ''}`}
            style={{ background: c }}
            onClick={() => onChange(c)}
          />
        ))}
        <input
          type="color"
          className="wall-style-box__custom-color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

// انتخاب‌گرِ یک «لایه‌ی پوشش» کامل — جنس (رنگِ ساده یا یک عکسِ واقعی) + رنگ
function CoveringEditor({ layer, onChange, label }) {
  const type = normalizeWallCoveringType(layer.type);
  const isPhoto = type !== 'paint';
  return (
    <div className="wall-style-box__covering">
      {label && <span className="wall-style-box__label">{label}</span>}
      <div className="wall-style-box__pills wall-style-box__pills--wrap">
        {COVERING_TYPES.map((t) => (
          <button
            key={t.value}
            type="button"
            className={type === t.value ? 'is-active' : ''}
            onClick={() => onChange({ type: t.value })}
          >
            {t.label}
          </button>
        ))}
      </div>
      {isPhoto && (
        <p className="wall-style-box__hint">
          {COVERING_HINTS[type]} سفید = رنگِ طبیعیِ خودِ عکس؛ هر رنگِ دیگری روی عکس ضرب می‌شود.
        </p>
      )}
      <ColorField
        label={isPhoto ? 'رنگ (روی عکسِ واقعی اعمال می‌شود)' : 'رنگ'}
        value={layer.color || '#ffffff'}
        presets={MAIN_COLOR_PRESETS}
        onChange={(color) => onChange({ color })}
      />
    </div>
  );
}

// پنلِ ادیتِ یک «رویه»‌ی دیوار در حالت سه‌بعدی — یک بشقاب ثابتِ پایین صفحه، تب‌بندی‌شده به سه بخش:
// پوشش (نوع/رنگ + پوشش دوم مثل کاشیِ تا نصفه)، براقیت، و قرنیز. عنوان پنل عمداً می‌گوید «این سمت»
// تا روشن باشد که تغییرات فقط روی همان رویه‌ای اعمال می‌شود که کاربر واقعاً لمس کرده، نه کل دیوار
function WallStyleBox({
  sideStyle,
  wallHeight,
  onChangeMain,
  onToggleLower,
  onChangeLower,
  onChangeFinish,
  onChangeBaseboard,
  onClose,
}) {
  const [activeTab, setActiveTab] = useState('covering');
  const style = sideStyle || DEFAULT_WALL_SIDE_STYLE;
  const main = style.main || DEFAULT_WALL_SIDE_STYLE.main;
  const lower = style.lower;
  const finish = style.finish || 'matte';
  const baseboard = style.baseboard || { enabled: false, color: '#cdc6b8' };
  const maxHeight = Math.max(30, (wallHeight || 280) - 20);

  return (
    <div className="wall-style-box">
      <div className="wall-style-box__header">
        <span>تنظیمات این سمت دیوار</span>
        <button type="button" onClick={onClose}>
          بستن
        </button>
      </div>

      <div className="wall-style-box__tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={activeTab === tab.id ? 'is-active' : ''}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'covering' && (
        <div className="wall-style-box__panel">
          <CoveringEditor layer={main} onChange={onChangeMain} />

          <div className="wall-style-box__field">
            <span className="wall-style-box__label">پوشش دوم (مثلاً کاشی تا نصفه)</span>
            <div className="wall-style-box__pills">
              <button type="button" className={!lower ? 'is-active' : ''} onClick={() => onToggleLower(false)}>
                ندارد
              </button>
              <button type="button" className={lower ? 'is-active' : ''} onClick={() => onToggleLower(true)}>
                دارد
              </button>
            </div>
          </div>

          {lower && (
            <>
              <div className="wall-style-box__field">
                <span className="wall-style-box__label">
                  ارتفاع پوشش پایین: {Math.round(lower.heightCm || 120)} سانتی‌متر
                </span>
                <input
                  type="range"
                  min={30}
                  max={maxHeight}
                  step={10}
                  value={Math.min(maxHeight, lower.heightCm || 120)}
                  onChange={(e) => onChangeLower({ heightCm: Number(e.target.value) })}
                  className="wall-style-box__slider"
                />
              </div>
              <CoveringEditor layer={lower} onChange={onChangeLower} label="پوشش پایین" />
            </>
          )}
        </div>
      )}

      {activeTab === 'finish' && (
        <div className="wall-style-box__panel">
          {normalizeWallCoveringType(main.type) === 'paint' ? (
            <div className="wall-style-box__field">
              <span className="wall-style-box__label">براقیت</span>
              <div className="wall-style-box__pills">
                <button
                  type="button"
                  className={finish === 'matte' ? 'is-active' : ''}
                  onClick={() => onChangeFinish('matte')}
                >
                  مات
                </button>
                <button
                  type="button"
                  className={finish === 'glossy' ? 'is-active' : ''}
                  onClick={() => onChangeFinish('glossy')}
                >
                  براق
                </button>
              </div>
            </div>
          ) : (
            <p className="wall-style-box__hint">براقیت فقط برای «رنگ ساده» قابل تنظیم است.</p>
          )}
        </div>
      )}

      {activeTab === 'baseboard' && (
        <div className="wall-style-box__panel">
          <div className="wall-style-box__field">
            <span className="wall-style-box__label">قرنیز</span>
            <div className="wall-style-box__pills">
              <button
                type="button"
                className={!baseboard.enabled ? 'is-active' : ''}
                onClick={() => onChangeBaseboard({ enabled: false })}
              >
                ندارد
              </button>
              <button
                type="button"
                className={baseboard.enabled ? 'is-active' : ''}
                onClick={() => onChangeBaseboard({ enabled: true })}
              >
                دارد
              </button>
            </div>
          </div>
          {baseboard.enabled && (
            <ColorField
              value={baseboard.color || '#cdc6b8'}
              presets={BASEBOARD_COLOR_PRESETS}
              onChange={(color) => onChangeBaseboard({ color })}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default WallStyleBox;